import React, { useState, useEffect } from "react";
import { Card, Avatar, Typography } from "antd";
import { Calendar } from "lucide-react";
import { get_api_function } from '@/utils/api';
import { defaultColors } from '@/themes/antd-theme';
import { formatDateTime } from '@/utils/datetime';

const { Paragraph } = Typography;

// ==============================|| SCHEDULE NOTIFICATION PAGE ||============================== //

const ScheduleNotificationPage = () => {
  const [notifications_data, set_notifications_data] = useState([]);

  useEffect(() => {
    get_api_function("/get_schedule_notification", (res) => {
      set_notifications_data(res?.data?.data);
    });
  }, []);

  return (
    <div className="p-3">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {notifications_data?.map((item, index) => (
          <Card key={index} className="hover:shadow-md transition-shadow">
            <div className="flex gap-3">
              <Avatar
                size={36}
                style={{
                  color: defaultColors.success,
                  backgroundColor: defaultColors.palette.green[50],
                }}
              >
                {item.recipe_name
                  .split(" ")
                  .map((word) => word[0])
                  .join("")
                  .toUpperCase()}
              </Avatar>
              <div className="flex-1">
                <Paragraph
                  ellipsis={{
                    rows: 2,
                    expandable: true,
                    symbol: "more",
                  }}
                  className="text-sm font-medium mb-2"
                >
                  {item?.msg}
                </Paragraph>

                <div className="grid grid-cols-2 gap-1 text-xs">
                  <span className="text-gray-600 dark:text-gray-400">Recipe:</span>
                  <span className="text-gray-900 dark:text-gray-100 truncate">
                    {item?.recipe_name}
                  </span>

                  <span className="text-gray-600 dark:text-gray-400">Batch Number:</span>
                  <span className="text-gray-900 dark:text-gray-100 truncate">
                    {item?.batch_number}
                  </span>

                  <span className="text-gray-600 dark:text-gray-400">Process Name:</span>
                  <span className="text-gray-900 dark:text-gray-100 truncate">
                    {item?.process_name}
                  </span>

                  <span className="text-gray-600 dark:text-gray-400">Schedule Time:</span>
                  <span className="text-gray-900 dark:text-gray-100 truncate">
                    {formatDateTime(item?.batch_schedule_time)}
                  </span>
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default ScheduleNotificationPage;
